import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

// Build stamp for cache-busting
const BUILD_STAMP = "2025-10-05T18:30:00";
console.log(`🚀 App build: ${BUILD_STAMP}`);

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
